<template>
    <div class="login-wrap">
        <header class="header" v-if="!isUmebro">
            <div class="container">
                <a href="home.html" class="logo">
                    <div class="logo-box">
                        <img src="images/logo-blue-white.svg" alt="">
                    </div>
                    
                    <span class="logo-txt">趣盟平台</span>
                </a>
                <a href="home.html" class="btn btn-blue btn-return">返回主页</a>
            </div>
        </header>
        <div class="login-con">
            <div class="login-bg">
            </div>
            <div class="container">
                <div class="login-section">
                    <h2>
                        欢迎使用<span v-if="!isUmebro">趣盟平台</span><span v-else>博色广告后台</span>
                    </h2>
                    
                    <div class="layui-form-item">
                        <input type="text" placeholder="请输入账号" autocomplete="off" class="layui-input" v-model="form.username" @blur="handleCheckCode">
                    </div>
                    <div class="layui-form-item">
                        <input type="password" name="password" placeholder="请输入登录密码" autocomplete="off" class="layui-input" v-model="form.password">
                    </div>
                    <div class="layui-form-item layui-form-item-flex" v-if="checkVerifyCode">
                        <div class="input-inline">
                            <input type="text" placeholder="请输入验证码" class="layui-input" v-model="form.code">
                        </div>
                        <div class="yzm">
                            <el-image
                                class="code-image"
                                :src="codeUrl"
                                fit="fill"
                                @click="getUserLoginCode"
                            />
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <button class="layui-btn" @click="doLogin" lay-filter="formDemo" v-loading="loading">登录</button>
                    </div>
                    <div class="tip-info" v-if="!isUmebro">如有问题联系<span>qumeng@qutoutiao.net</span></div>
                </div>
            </div>
        </div>
        <footer>
            <div class="container">
                <div class="left">
                    <a href="javascript:;" v-if="!isUmebro">Copyright © 2024 上海姜盘信息科技有限公司 保留所有权利。</a>
                    <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" v-if="!isUmebro">沪ICP备2024046462号-1</a>
                    <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" v-if="isUmebro">沪ICP备16009033号-6</a>
                </div>
                <div class="right" v-if="!isUmebro">
                    qumeng@qutoutiao.net
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { isUmebro } from '../../common/utils';
import { getUserLoginCode, doPasswordLogin, verifyCode } from '@/apis/login.js';
// import { localStorage } from '@/common/storage';
import { TOKEN } from '@/common/storageKeys';

export default {
    name: 'new-login',
    data() {
        return {
            form: {
                username: '',
                password: '',
                code: '',
            },
            codeUrl: '',
            loading: false,
            captchaId: '',
            checkVerifyCode: false,
        }
    },
    computed: {
        isUmebro () {
            return isUmebro()
        },
    },
    created() {
        document.title = this.isUmebro ? '博色广告后台' : '登录-趣盟广告平台';
        this.getUserLoginCode();
    },
    methods: {
        async getUserLoginCode() {
            const res = await getUserLoginCode();
            this.$ls.set('captchaId', res.headers['captcha-id']);
            let reader = new FileReader();
            let me = this;
            reader.onload = function(e) {
                me.codeUrl = e.target.result;
            };
            reader.readAsDataURL(res.data);
        },
        async handleCheckCode() {
            if (!this.form.username) {
                console.log('用户名未输入...');
                return;
            }
            const res = await verifyCode({ username: this.form.username });
            if (res && res.code === 200) {
                this.checkVerifyCode = res.data.need_capture;
            }
        },
        async doLogin() {
            await this.handleCheckCode();
            const { username = '', password = '', code = '' } = this.form;
            if (!username) {
                this.$message.error('请输入用户名');
                return;
            }
            if (!password) {
                this.$message.error('请输入密码');
                return;
            }
            if (this.checkVerifyCode && !code) {
                this.$message.error('请输入验证码');
                return;
            }
            this.loading = true;
            const res = await doPasswordLogin({
                ...this.form,
                captcha_id: this.$ls.get('captchaId'),
            }).finally(() => {
                this.loading = false;
            });
            this.$ls.set(TOKEN, res.data.token);
            this.$router.push('/flow/applist');
        }
    },
}
</script>